'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Label = require('../Label/Label');

var _Label2 = _interopRequireDefault(_Label);

var _Container = require('./components/Container.CheckBox');

var _Container2 = _interopRequireDefault(_Container);

var _Content = require('./components/Content.CheckBox');

var _Content2 = _interopRequireDefault(_Content);

var _IconContainer = require('./components/IconContainer.CheckBox');

var _IconContainer2 = _interopRequireDefault(_IconContainer);

var _Mark = require('./components/Mark.CheckBox');

var _Mark2 = _interopRequireDefault(_Mark);

var _Svg = require('./components/Svg.CheckBox');

var _Svg2 = _interopRequireDefault(_Svg);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Components


var CheckBox = function CheckBox(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      children = _ref.children,
      size = _ref.size,
      disabled = _ref.disabled,
      green = _ref.green,
      inline = _ref.inline,
      bigLabel = _ref.bigLabel;
  return _react2.default.createElement(_Label2.default, {
    label: children,
    inline: inline,
    big: bigLabel
  }, _react2.default.createElement(_Container2.default, {
    on: value ? 1 : 0,
    onClick: function onClick(e) {
      if (disabled) return;
      onChange(!value);
    },
    size: size,
    disabled: disabled,
    green: green
  }, _react2.default.createElement(_Content2.default, {
    on: value ? 1 : 0
  }, _react2.default.createElement(_IconContainer2.default, null, _react2.default.createElement(_Mark2.default, {
    size: size
  }, _react2.default.createElement(_Svg2.default, {
    viewBox: '0 0 24 24',
    on: value ? 1 : 0,
    disabled: disabled
  }, _react2.default.createElement('path', {
    d: 'M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z'
  })))), _react2.default.createElement(_IconContainer2.default, null, _react2.default.createElement(_Mark2.default, {
    size: size
  }, _react2.default.createElement(_Svg2.default, {
    viewBox: '0 0 24 24',
    on: value ? 1 : 0,
    disabled: disabled
  }, _react2.default.createElement('path', {
    d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
  })))))));
};

CheckBox.propTypes = {
  value: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.node,
  size: _propTypes2.default.oneOf(['small', 'normal', 'large', 'giant']),
  disabled: _propTypes2.default.bool,
  green: _propTypes2.default.bool,
  inline: _propTypes2.default.bool,
  bigLabel: _propTypes2.default.bool
};
CheckBox.defaultProps = {
  label: null,
  size: 'normal',
  disabled: false,
  green: false,
  inline: false,
  bigLabel: false
};
exports.default = CheckBox;